export default "__VITE_ASSET__B9VlAn48__"